import logoLarge from '../assets/images/logo-large.png';
import logoSmall from '../assets/images/logo-small.png';
import searchIcon from '../assets/icons/search.png';
import menuIcon from '../assets/icons/menu.png';
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import Menu from "./Menu";
import BackButton from "./BackButton";

function TopBar({title, count}: any) {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isOpenMenu, setIsOpenMenu] = useState(false);

    useEffect(() => {
        window.addEventListener('scroll', () => {
            const headerHeight = document?.querySelector('header')?.offsetHeight ?? 140;
            setIsScrolled(window.scrollY > headerHeight);
        })
    }, []);

    function openMenuHandler() {
        setIsOpenMenu((prev) => !prev)
    }

    /**
     * This is a little bit dirty but allows us to not use redux / context for a single component.
     */
    function shouldShowBackButton() {
        return window.location.pathname !== '/' && window.location.pathname !== '/sok';
    }

    return (
        <header className="sticky top-0 z-20">
        <div className="w-full flex flex-wrap justify-between items-center p-4 xl:px-8 bg-white shadow-[0_2px_4px_rgba(0,0,0,0.40)]">
            <div className="xl:w-24 relative">
                <Link to='/'>
                    <div className={`w-[50px] h-[68px] m-5 ${isScrolled ? 'hidden' : 'block'}`}>
                        <img src={logoLarge} alt="Sveriges Ingenjörer logotype"/>
                    </div>
                    <div className={`w-[40px] h-[40px] m-2 ms-0 ${!isScrolled ? 'hidden' : 'block'}`}>
                        <img src={logoSmall} alt="Sveriges Ingenjörer logotype"/>
                    </div>
                </Link>
                <div className={`hidden absolute z-20 ${isScrolled ? 'left-0' : 'left-4'} bottom-[-80px] xl:block`}>
                    {shouldShowBackButton() && <BackButton />}
                </div>
            </div>

            <div className="flex gap-4 justify-end xl:order-last xl:w-24">
                <button className="cursor-pointer">
                    <Link to='/sok'>
                        <img src={searchIcon} alt="Search" width="30" height="30"/>
                    </Link>
                </button>
                <button className="cursor-pointer" onClick={openMenuHandler}>
                    <img src={menuIcon} alt="Menu" width="30" height="30"/>
                </button>
                {isOpenMenu && <Menu onClose={openMenuHandler} />}
            </div>

            <div className={`w-full flex grow justify-between xl:w-auto xl:self-end xl:max-w-3xl ${isScrolled ? 'xl:mb-2' : 'xl:mb-5'}`}>
                <div>
                    <h1 className="font-sweing font-medium text-lg text-black leading-5 xl:text-3xl">{title}</h1>
                    <p className="font-body text-xs text-grey-700">Statistik för senaste 12 månaderna</p>
                </div>
                <div className="text-right">
                    {count !== null && <>
                        <p className="font-sweing text-lg text-rose leading-5 xl:text-3xl">{count > 0 ? count.toLocaleString('sv') : 0}</p>
                        <p className="font-body text-xs text-grey-700">Historiska annonser</p>
                    </>}
                </div>
            </div>
        </div>
        </header>
    );
}

export default TopBar;